/**
 * OpsCriadasHojeWidget — OPs criadas hoje (proxy de demanda do dia).
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarOrdensProducao } from "../../../services/producao";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "ops_criadas_hoje",
  label: "OPs criadas hoje",
  descricao: "Quantas Ordens de Produção foram criadas hoje.",
  categoria: "Produção",
  permissoes: ["ordem_producao:view"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const inicio = new Date();
  inicio.setHours(0, 0, 0, 0);
  const payload = await listarOrdensProducao(request, {
    created_at_inicio: inicio.toISOString(),
    pageSize: 1,
  });
  const c = Array.isArray(payload) ? payload.length : (payload?.count ?? (payload?.results || []).length);
  return { criadas_hoje: c };
}

export function Widget({ dados }) {
  return (
    <>
      <CardBody>
        <KpiValor>{dados?.criadas_hoje ?? 0}</KpiValor>
        <KpiSub>OPs geradas hoje</KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/producao">Ver produção</LinkLight>
      </CardFooter>
    </>
  );
}
